import { message } from 'antd';

import { call, put, takeEvery, all, fork } from 'redux-saga/effects'
import {
    FETCH_HL7_RECEIVED_MESSAGES, FETCH_HL7_RECEIVED_MESSAGES_START, FETCH_HL7_RECEIVED_MESSAGES_SUCCESS, FETCH_HL7_RECEIVED_MESSAGES_ERROR
} from "../../actions/admin/hl7ReceivedMessagesActions";
import { getHL7ReceivedMessagesAPI } from "../../../services/hl7-received-message-service";

function* fetchHL7ReceivedMessages({ action, payload }) {
    try {
        yield put({ type: FETCH_HL7_RECEIVED_MESSAGES_START })
        const response = yield call(getHL7ReceivedMessagesAPI, payload);
        if (response.success) {
            const data = {
                pagination: {
                    currentPage: payload.page,
                    pageSize: payload.size,
                    totalPages: response.data.totalPages,
                    totalItems: response.data.totalItems,
                },
                hl7ReceivedMessages: [...response.data.hl7ReceivedList]
            }
            yield put({ type: FETCH_HL7_RECEIVED_MESSAGES_SUCCESS, data })
        } else {
            yield put({ type: FETCH_HL7_RECEIVED_MESSAGES_ERROR, error: response.error })
            message.error('Failed to fetch HL7 in messages!');
        }
    } catch (error) {
        yield put({ type: FETCH_HL7_RECEIVED_MESSAGES_ERROR, error })
        message.error('Failed to fetch in messages!');
    }
}

function* adminHL7ReceivedMessagesWatcher() {
    yield takeEvery(FETCH_HL7_RECEIVED_MESSAGES, fetchHL7ReceivedMessages)
}

export default function* rootSaga() {
    yield all([
        adminHL7ReceivedMessagesWatcher(),
    ]);
}